import { createFileRoute } from "@tanstack/react-router";
import { canonicalSiteUrl, site } from "@softmax/web-addresses/discovery";
import { OfficeLayout } from "@/features/office";

export const Route = createFileRoute("/_office")({
  head: () => ({
    meta: [
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:type", content: "website" },
      { property: "og:site_name", content: "Softmax" },
      { property: "og:title", content: site.name },
      { property: "og:description", content: site.agentSummary },
      { property: "og:image", content: canonicalSiteUrl("/opengraph-image") },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: site.name },
      { name: "twitter:description", content: site.agentSummary },
      { name: "twitter:image", content: canonicalSiteUrl("/twitter-image") },
    ],
  }),
  component: OfficeLayout,
});
